var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 40,
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.8796 8.33005C22.9767 8.32917 22.111 7.9701 21.4725 7.33163C20.8341 6.69316 20.475 5.82746 20.4741 4.92452V0.197754H5.25661C4.07789 0.197754 2.94746 0.666 2.11398 1.49948C1.2805 2.33296 0.812256 3.46339 0.812256 4.6421V31.4338C0.814006 32.6113 1.28302 33.7401 2.11631 34.5721C2.9496 35.4042 4.07903 35.8715 5.25661 35.8715H23.5245C24.7024 35.8715 25.8321 35.4039 26.6654 34.5715C27.4988 33.7391 27.9676 32.61 27.9689 31.4321V8.33005H23.8796Z",
    fill: "#005FAD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9688 8.33005H23.8795C22.9766 8.32917 22.1109 7.9701 21.4724 7.33163C20.8339 6.69316 20.4749 5.82746 20.474 4.92452V0.197754L27.9688 8.33005Z",
    fill: "#005FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.191 28.3735H10.5399C9.07498 28.3735 7.88745 29.5611 7.88745 31.026V37.183C7.88745 38.6478 9.07498 39.8354 10.5399 39.8354H31.191C32.6559 39.8354 33.8434 38.6478 33.8434 37.183V31.026C33.8434 29.5611 32.6559 28.3735 31.191 28.3735Z",
    fill: "#005FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8689 35.4373V36.6379H12.6252V35.4373H13.8689Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.696 34.8971V36.6379H14.4937V31.6716H16.4392C17.0305 31.6716 17.4802 31.8181 17.7885 32.1109C17.945 32.2644 18.0673 32.4493 18.1473 32.6534C18.2272 32.8575 18.2631 33.0762 18.2526 33.2951C18.2578 33.584 18.186 33.869 18.0445 34.1209C17.9011 34.3674 17.6871 34.5653 17.4301 34.689C17.1211 34.8364 16.7814 34.9078 16.4392 34.8971H15.696ZM17.0305 33.2951C17.0305 32.8547 16.7893 32.6345 16.3071 32.6345H15.696V33.9277H16.3071C16.7893 33.9321 17.0305 33.7212 17.0305 33.2951Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2538 36.6379H22.0531L20.0415 33.5891V36.6379H18.8408V31.6716H20.0415L22.0515 34.7485V31.6716H23.2521L23.2538 36.6379Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9454 32.0729C28.3462 32.3728 28.6154 32.816 28.6969 33.3099H27.4252C27.3418 33.133 27.2079 32.9847 27.0403 32.8838C26.8511 32.7716 26.6344 32.7144 26.4144 32.7186C26.2435 32.7116 26.0732 32.7421 25.9154 32.808C25.7576 32.8739 25.6162 32.9736 25.5011 33.1001C25.2598 33.3901 25.1371 33.7606 25.1576 34.1373C25.1576 34.6097 25.2781 34.9725 25.5193 35.2257C25.6548 35.3573 25.8163 35.459 25.9935 35.5245C26.1707 35.5899 26.3597 35.6175 26.5482 35.6056C26.8176 35.6102 27.0813 35.5273 27.2996 35.3694C27.522 35.2029 27.6825 34.9669 27.7555 34.6989H26.2393V33.8351H28.7613V35.0457C28.6636 35.3411 28.5106 35.6151 28.3104 35.8533C28.0942 36.1096 27.8248 36.3159 27.5209 36.4578C27.1764 36.6168 26.8004 36.6959 26.421 36.689C25.96 36.7006 25.5042 36.5901 25.0998 36.3686C24.7297 36.1611 24.4283 35.8499 24.2327 35.4734C24.0233 35.068 23.9183 34.6167 23.9272 34.1604C23.9172 33.7014 24.0223 33.2472 24.2327 32.8392C24.428 32.4636 24.7281 32.1527 25.0965 31.944C25.495 31.7245 25.9446 31.6145 26.3995 31.6253C26.9503 31.5983 27.4943 31.7558 27.9454 32.0729Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84634 11.217H7.57544V13.4879H9.84634V11.217Z",
    fill: "#005FAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1188 13.4878H9.8479V15.7587H12.1188V13.4878Z",
    fill: "#005FAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3893 11.217H12.1184V13.4879H14.3893V11.217Z",
    fill: "#005FAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6606 13.4878H14.3896V15.7587H16.6606V13.4878Z",
    fill: "#005FAD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9348 11.217H16.6639V13.4879H18.9348V11.217Z",
    fill: "#005FAD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2052 13.4878H18.9343V15.7587H21.2052V13.4878Z",
    fill: "#005FAD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84634 15.7554H7.57544V18.0263H9.84634V15.7554Z",
    fill: "#005FAD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1188 18.0264H9.8479V20.2973H12.1188V18.0264Z",
    fill: "#005FAD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3893 15.7554H12.1184V18.0263H14.3893V15.7554Z",
    fill: "#005FAD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6606 18.0264H14.3896V20.2973H16.6606V18.0264Z",
    fill: "#005FAD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9348 15.7554H16.6639V18.0263H18.9348V15.7554Z",
    fill: "#005FAD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2052 18.0264H18.9343V20.2973H21.2052V18.0264Z",
    fill: "#005FAD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9.84634 20.3154H7.57544V22.5863H9.84634V20.3154Z",
    fill: "#005FAD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1188 22.5864H9.8479V24.8573H12.1188V22.5864Z",
    fill: "#005FAD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3893 20.3154H12.1184V22.5863H14.3893V20.3154Z",
    fill: "#005FAD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6606 22.5864H14.3896V24.8573H16.6606V22.5864Z",
    fill: "#005FAD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9348 20.3154H16.6639V22.5863H18.9348V20.3154Z",
    fill: "#005FAD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2052 22.5864H18.9343V24.8573H21.2052V22.5864Z",
    fill: "#005FAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.f2735254492ce0865e7cae194cdeb16d.svg";
export { ForwardRef as ReactComponent };